import { Injectable } from '@angular/core';
import { AccountSharingAlert } from '../model/response/auth-response';

const STORAGE_KEY = 'accountSharingAlert';

/**
 * Ponte entre quem recebe o aviso de acesso simultâneo (login por e-mail/senha, MFA e
 * callback do OAuth) e quem o exibe (shell do dashboard). As duas pontas são telas
 * diferentes e o caminho entre elas pode passar por um reload — daí o sessionStorage
 * em vez de um Subject em memória.
 *
 * Chave one-shot: consume() lê e apaga, então o aviso aparece uma vez por login e não
 * volta a cada navegação para o shell.
 */
@Injectable({ providedIn: 'root' })
export class AccountSharingAlertService {

  /** Ausente/nulo é o caso normal (sem detecção) e não grava nada. */
  store(alert: AccountSharingAlert | null | undefined): void {
    if (!alert) return;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(alert));
  }

  consume(): AccountSharingAlert | null {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as AccountSharingAlert;
    } catch {
      // Valor adulterado no storage do browser: o aviso é informativo, não vale
      // derrubar o boot do shell por causa dele.
      return null;
    }
  }
}
